import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Form from './form/Form';
import { get_showroom_details } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class EditShowroom extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            property_id: this.props.match.params.id,
            values: null
        };
    }

    async get_data() {
        let data = await get_showroom_details(this.state.property_id);
        if (data) {
            this.setState({
                ...this.state,
                values: data
            });
        }
    }

   
    componentWillMount() {
        this.setState({
            property_id: this.props.match.params.id,
            values: null
        }, () => {
            this.get_data();
        });

    }

    render() {
        return (

            <div className={clsx(this.props.classes.root, this.props.className)} >
                {
                    this.state.values && (

                        <Form
                            showroom={this.state.values}
                        />
                    )
                }
            </div>
        )
    }

}
